
<!-- {{customers_list.name}} -->
<div class="customer__details">
  <!-- [ngClass]="close_customerInfo?'':'customer_dis'" -->
  <!-- ---------- -->
  <div class="cus__details">
    <div class="customer__information d__flex_justify">
      <p>Customer Information</p>
      <!-- <div *ngIf="customers_list" class="customer__image">
        <div>{{customers_list.first_name[0]}}</div>
      </div> -->
    </div>
    <!-- ---------- -->
    <!-- <div *ngIf="db.isMobile" class="mob__customerDetails">
      <div class="">    
        <div class="customer__info" *ngIf="customers_list">
          <div class="d__flex">
            <ion-icon class="person__outline" name="person-outline"></ion-icon>
            <div class="cus__name">{{customers_list.full_name}}</div>
          </div>
          <div class="d__flex">
            <ion-icon class="mail__unread__outline" *ngIf="customers_list.email" name="mail-unread-outline"></ion-icon>
            <div class="cus__email">{{customers_list.email}}</div>
          </div>
          <div class="d__flex">
            <ion-icon class="id__card__outline" *ngIf="customers_list.phone" name="id-card-outline"></ion-icon>
            <div class="call__outline">{{customers_list.phone}}</div>
          </div>
        </div>
    </div>
  </div> -->
    <!-- ----------- -->
    <div class="customer__datas d__flex_justify">
      <div class="">    
        <div class="customer__info" *ngIf="customers_list">
          <div class="d__flex">
            <ion-icon class="person__outline" name="person-outline"></ion-icon>
            <div class="cus__name">{{customers_list.full_name}}</div>
          </div>
          <div class="d__flex">
            <ion-icon class="mail__unread__outline" *ngIf="customers_list.email" name="mail-unread-outline"></ion-icon>
            <div class="cus__email">{{customers_list.email}}</div>
          </div>
          <div class="d__flex">
            <ion-icon class="id__card__outline" *ngIf="customers_list.phone" name="id-card-outline"></ion-icon>
            <div class="call__outline">{{customers_list.phone}}</div>
          </div>
        </div>
      </div>
      <div class="d__flex_justify">     
        <div class="loyal__points_data">
          <div class="loylty__points">
            <p>500</p>
            <img src="" alt="">
          </div>
          <div class="loyalty__point">
            <p>Loyalty Points</p>   
          </div>
        </div>

        <div>
          <div>
            <img src="" alt="">
          </div>
          <div class="average__rating">
            Average Rating
          </div>
        </div>
        <div>
          <div>
            <img src="" alt="">
          </div>
          <div class="platinum__member">
            platinum Member
          </div>
        </div>

        <div class="edit__button">
          <ion-button  color="" fill="clear" (click)="edit_customer('customers_list')">Edit</ion-button>
        </div>

        <div class="ion__button">
          <ion-button  color="" fill="clear" (click)="presentModal()">My Address</ion-button>
        </div>
      </div>
    </div>
  </div>
      <!-- ---------- -->

  <div class="order__data">Customer Orders </div>
 

    <div  class="order__payment__list d__flex">
      <div  class="orders__list">
        <!-- <div class="" *ngIf="db.allOrders && db.allOrders">
          <img src="..\assets\images\empty-cart-01.svg" alt="">
          <h1 class="ion_text_center">No Orders Yet.....!</h1>
        </div> -->
          <div *ngIf="db.allOrders" class="orderDatas">   
            <!--  -->
          <div class="all__Orders  d__flex_justify" *ngFor="let item of db.allOrders" 
          [class.active__item]="(item && item.name) == (items && items.name)" (click)="order_click(item)">
            <div class="date__time__data"> 
              <div class="order__dateTime d__flex">
                <div class="data__time">{{item.order_date}}</div>
                <div *ngIf="item.order_time" class="datas__time">At  {{item.order_time}}</div>
              </div>
              <div class="order__id">{{item.name}}</div>
            </div>
            <div class="price__button">
              <div class="price">₹{{item.total_amount}}</div>
              <div class="ion__button__recorder">
                <ion-button color="" fill="clear">Recorder</ion-button>
              </div>
            </div>
            </div>
          </div>        
      </div>

      <div class="orders__view" *ngIf="!items">
        <img src="..\assets\images\empty-cart-01.svg" alt="">
        <h1 class="ion_text_center">Please Select Orders to view</h1>
      </div>
      <!-- ------------------------- -->
      <div *ngIf="items" class="payment__list">
        <div>    
            <div class="d__flex_justify">
              <div *ngIf="items" class="cus__date__time__data">
                <div class="d__flex">
                  <div class="data__time">{{items.order_date}}</div>
                  <div *ngIf="items.order_time" class="datas__time">At  {{items.order_time}}</div>
                </div>
                <div class="order__id">{{items.name}}</div>
              </div>
              <div>  
                <div *ngIf="items" class="ion__button__payment">
                  <ion-button color="" fill="clear">Recorder</ion-button>
                </div>
              </div>
          
          </div>
          <div *ngIf="items">
            <div class="productItemList" >
              <div class="product__items">Items</div>
              <div class="productItems">
                <div class="mai2__dumpling d__flex_justify" *ngFor="let item of items.Items">
                  <div class="siu__mai">{{item.item_name}}</div>
                  <div class="price">₹{{item.price}}</div>
                </div>
              </div>
                <div class="total__Price">
                  <div class="total">Total</div>
                  <div class="price">₹{{items.total_amount}}</div>
                </div>
            </div>
          </div>
        </div>
          <div *ngIf="items">
            <div class="discount__payment__source">
              <div>
                <div class="title__source" *ngIf="items.payment_type">Payment</div>
                <div class="description">{{items.payment_type}}</div>
              </div>
            </div>
          </div>
      </div>
      <!-- ---------------------------- -->
      <!-- ----------------------------- -->
    </div>
  <!-- ---------- -->

</div>
